import mrFutureRequest from "../utils/mrFutureRequest";

export function getHostNameByZys(equipmentHostSerial) {
  return mrFutureRequest({
    url: "/equipment-zys/supplier/equipment/host/getName",
    method: "get",
    headers: { "Content-Type": "application/json" },
    params: { equipmentHostSerial }
  });
}

export function getHostNameByLyj(equipmentHostSerial) {
  return mrFutureRequest({
    url: "/equipment-lyj/supplier/equipment/host/getName",
    method: "get",
    headers: { "Content-Type": "application/json" },
    params: { equipmentHostSerial }
  });
}
